import DeleteIcon from 'assets/settings/components/DeleteIcon';
import EditIcon from 'assets/settings/components/EditIcon';

import {
  ActionButton,
  ActionsSection,
  Card,
  CardHeader,
  Description,
  IconWrapper,
  StatusBadge,
  Title,
  TitleSection,
} from './LeadSourceCard.styles';

const LeadSourceCard = ({ icon, title, status, description, onEdit, onDelete }) => {
  return (
    <Card>
      <CardHeader>
        <IconWrapper>{icon}</IconWrapper>
        <TitleSection>
          <Title title={title}>{title}</Title>
          <StatusBadge $status={status}>{status}</StatusBadge>
        </TitleSection>
        <ActionsSection>
          <ActionButton onClick={onEdit}>
            <EditIcon size={16} color="#2D6CDF" />
          </ActionButton>
          <ActionButton onClick={onDelete} $delete>
            <DeleteIcon size={16} color="#FB2C36" />
          </ActionButton>
        </ActionsSection>
      </CardHeader>
      <Description title={description}>{description}</Description>
    </Card>
  );
};

export default LeadSourceCard;
